import React from 'react'
import PropTypes from 'prop-types'
import CreateCourse from 'experienceComponents/CreateCourse'
import CreateSmallGroup from 'experienceComponents/CreateSmallGroup'

const noop = () => {}

export const CreateClassModals = ({
  contentfulCourses,
  createCourseAutoOpen,
  createCourseInstance,
  createCourseInstanceV2,
  createCourseInstanceV2ProgramFlex,
  createSmallGroupAutoOpen,
  showSmallGroupCreation = true,
  deleteCourseInstance,
  deletingCourseCreatedStatus,
  lms,
  pathName,
  updateCourseInstance,
  userAccess,
  userContext,
  userProfile,
}) => {
  const sharedModalProps = {
    contentfulCourses,
    createCourseInstance,
    createCourseInstanceV2,
    createCourseInstanceV2ProgramFlex,
    deleteCourseInstance,
    deletingCourseCreatedStatus,
    emptyClasses: true,
    fetchInstructorData: noop,
    hideLauncher: true,
    lms,
    pathName,
    updateCourseInstance,
    userAccess,
    userContext,
    userProfile,
  }

  return (
    <>
      <CreateCourse autoOpen={createCourseAutoOpen} {...sharedModalProps} />
      {showSmallGroupCreation && (
        <CreateSmallGroup
          autoOpen={createSmallGroupAutoOpen}
          {...sharedModalProps}
        />
      )}
    </>
  )
}

CreateClassModals.propTypes = {
  contentfulCourses: PropTypes.arrayOf(
    PropTypes.shape({
      displayTitle: PropTypes.string,
    }),
  ).isRequired,
  createCourseAutoOpen: PropTypes.bool.isRequired,
  createCourseInstance: PropTypes.func,
  createCourseInstanceV2: PropTypes.func,
  createCourseInstanceV2ProgramFlex: PropTypes.func,
  createSmallGroupAutoOpen: PropTypes.bool.isRequired,
  deleteCourseInstance: PropTypes.func,
  deletingCourseCreatedStatus: PropTypes.func,
  lms: PropTypes.object,
  pathName: PropTypes.string,
  showSmallGroupCreation: PropTypes.bool,
  updateCourseInstance: PropTypes.func,
  userAccess: PropTypes.object,
  userContext: PropTypes.object,
  userProfile: PropTypes.object,
}
